<ng-template #dialogTitle>
    <div class="entity-block-management-dialog__title">
        <i class="entity-block-management-dialog__title-icon" [ngClass]="dialogTitleIconClass()" aria-hidden="true"></i>
        <span>{{ dialogTitleText() }}</span>
    </div>
</ng-template>

<app-form-popup
    [width]="500"
    [height]="475"
    [visible]="visible()"
    [titleText]="dialogTitleText()"
    [titleTemplate]="dialogTitle"
    [wrapperAttr]="{ class: 'entity-block-management-dialog' }"
    [footerButtons]="footerButtons()"
    (clicked)="onFooterClicked($event)"
    (visibleChange)="onVisibleChange($event)"
>
    <div class="entity-block-management-dialog__content">
        @if (isLoading()) {
            <div class="entity-block-management-dialog__loading">
                <dx-load-indicator [visible]="true"></dx-load-indicator>
            </div>
        } @else if (!hasSelectedItem()) {
            <p class="entity-block-management-dialog__empty">
                {{ (isRequiredActionMode() ? 'no_required_actions_found' : 'no_blocks_found') | transloco }}
            </p>
        } @else {
            <dx-tabs
                class="entity-block-management-dialog__tabs"
                [items]="tabItems()"
                [selectedItem]="selectedTabItem()"
                (onItemClick)="onTabClick($event)"
                [width]="'fit-content'"
                [showNavButtons]="false"
                [scrollByContent]="true"
                itemTemplate="tabItem"
            >
                <div *dxTemplate="let item of 'tabItem'">
                    {{ item.text }}
                </div>
            </dx-tabs>

            <div class="entity-block-management-dialog__detail-row">
                <span class="entity-block-management-dialog__detail-label">{{ 'label_status' | transloco }}</span>
                <app-status-badge
                    [status]="isRequiredActionMode() ? actionRequiredStatus : blockedStatus"
                    [translationPrefix]="statusTranslationPrefix()"
                />
            </div>

            <div class="entity-block-management-dialog__detail-row">
                <span class="entity-block-management-dialog__detail-label">{{ 'label_blockReason' | transloco }}</span>
                @if (!isRequiredActionMode() && isEditing()) {
                    <dx-select-box
                        class="entity-block-management-dialog__reason-select"
                        [items]="reasonOptions()"
                        displayExpr="text"
                        valueExpr="value"
                        [value]="editFormData().reason"
                        [searchEnabled]="true"
                        [showClearButton]="false"
                        stylingMode="outlined"
                        [placeholder]="'placeholder_select_block_reason' | transloco"
                        (onValueChanged)="onReasonChanged($event.value)"
                    ></dx-select-box>
                } @else {
                    <span class="entity-block-management-dialog__detail-value">{{ selectedReasonLabel() }}</span>
                }
            </div>

            <div class="entity-block-management-dialog__detail-row">
                <span class="entity-block-management-dialog__detail-label">
                    {{ (isRequiredActionMode() ? 'label_creationDate' : 'label_blockedSince') | transloco }}
                </span>
                <span class="entity-block-management-dialog__detail-value">{{ sinceLabel() }}</span>
            </div>

            <div class="entity-block-management-dialog__detail-row">
                <span class="entity-block-management-dialog__detail-label">
                    {{ (isRequiredActionMode() ? 'label_createdBy' : 'label_blockedBy') | transloco }}
                </span>
                <span class="entity-block-management-dialog__detail-value">{{ byLabel() }}</span>
            </div>

            <div class="entity-block-management-dialog__description-section">
                <span class="entity-block-management-dialog__description-label">{{ 'label_description' | transloco }}</span>
                @if (!isRequiredActionMode() && isEditing()) {
                    <dx-text-area
                        class="entity-block-management-dialog__description-input"
                        [value]="editFormData().description"
                        [minHeight]="96"
                        [autoResizeEnabled]="true"
                        [maxLength]="descriptionMaxLength"
                        stylingMode="outlined"
                        [placeholder]="'placeholder_block_description' | transloco"
                        (onValueChanged)="onDescriptionChanged($event.value)"
                    ></dx-text-area>
                } @else {
                    <div class="entity-block-management-dialog__description-readonly">
                        {{ descriptionValue() }}
                    </div>
                }
            </div>
        }
    </div>
</app-form-popup>
